var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-button',{staticClass:"md-icon-button",attrs:{"title":_vm.text},on:{"click":function($event){return _vm.action()}}},[_c('md-icon',{staticClass:"text-gray"},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }